import {
  UserOutlined,
  HomeOutlined,
  IssuesCloseOutlined,
  ProfileOutlined,
  AppstoreOutlined,
  AppstoreAddOutlined,
} from "@ant-design/icons";
import Home from "./pages/customer/Home";
import ManageServiceUse from "./pages/admin/ManageServiceUse";
import ManageServiceUser from "./pages/customer/ManageServiceUser";
import ManageEvents from "./pages/customer/ManageEvents";
import ManageDevice from "./pages/customer/ManageDevice";
import ManageEquipment from "./pages/customer/ManageEquipment";
import ManageResistDevice from "./pages/customer/ManageResistDevice";
import Statics from "./pages/customer/Statics";
import { ReactComponent as MachineAddIcon } from "./assets/images/icon_machine-add_gray_20.svg";

export const adminMenuData = [
  {
    key: "home",
    title: "HOME",
    link: "/home",
    icon: <HomeOutlined />,
    pageComponent: <Home />,
  },
  {
    key: "manageServiceUser",
    title: "서비스 사용자 관리",
    link: "/manageServiceUser",
    icon: <UserOutlined />,
    pageComponent: <ManageServiceUser />,
  },
  {
    key: "serviceUse",
    title: "서비스 이용",
    subMenu: [
      {
        key: "manageEvents",
        title: "이벤트 관리",
        link: "/manageEvents",
        icon: <IssuesCloseOutlined />,
        pageComponent: <ManageEvents />,
        new: true,
      },
      {
        key: "manageDevice",
        title: "디바이스 상태 관리",
        link: "/manageDevice",
        icon: <AppstoreOutlined />,
        pageComponent: <ManageDevice />,
        alarm: 0,
      },
      {
        key: "manageEquipment",
        title: "장비 등록 관리",
        link: "/manageEquipment",
        icon: <MachineAddIcon />,
        pageComponent: <ManageEquipment />,
      },
      {
        key: "manageResistDevice",
        title: "디바이스 등록 관리",
        link: "/manageResistDevice",
        icon: <AppstoreAddOutlined />,
        pageComponent: <ManageResistDevice />,
      },
      {
        key: "statics",
        title: "통계 조회",
        link: "/statics",
        icon: <AppstoreAddOutlined />,
        pageComponent: <Statics />,
      },
    ],
  },
];

export const customerMenuData = [
  {
    key: "home",
    title: "HOME",
    link: "/home",
    icon: <HomeOutlined />,
    pageComponent: <Home />,
  },
  {
    key: "manageServiceUser",
    title: "서비스 사용자 관리",
    link: "/manageServiceUser",
    icon: <UserOutlined />,
    pageComponent: <ManageServiceUser />,
  },
  {
    key: "serviceUse",
    title: "서비스 이용",
    subMenu: [
      {
        key: "manageEvents",
        title: "이벤트 관리",
        link: "/manageEvents",
        icon: <IssuesCloseOutlined />,
        pageComponent: <ManageEvents />,
        new: true,
      },
      {
        key: "manageDevice",
        title: "디바이스 상태 관리",
        link: "/manageDevice",
        icon: <AppstoreOutlined />,
        pageComponent: <ManageDevice />,
        alarm: 0,
      },
      {
        key: "manageEquipment",
        title: "장비 등록 관리",
        link: "/manageEquipment",
        icon: <MachineAddIcon />,
        pageComponent: <ManageEquipment />,
      },
      {
        key: "manageResistDevice",
        title: "디바이스 등록 관리",
        link: "/manageResistDevice",
        icon: <AppstoreAddOutlined />,
        pageComponent: <ManageResistDevice />,
      },
      {
        key: "statics",
        title: "통계 조회",
        link: "/statics",
        icon: <AppstoreAddOutlined />,
        pageComponent: <Statics />,
      },
    ],
  },
];

export const deviceMenuData = [
  {
    key: "home",
    title: "HOME",
    link: "/home",
    icon: <HomeOutlined />,
    pageComponent: <Home />,
  },
  {
    key: "serviceUse",
    title: "서비스 이용",
    subMenu: [
      {
        key: "manageEvents",
        title: "이벤트 관리",
        link: "/manageEvents",
        icon: <IssuesCloseOutlined />,
        pageComponent: <ManageEvents />,
        new: true,
      },
      {
        key: "manageDevice",
        title: "디바이스 상태 관리",
        link: "/manageDevice",
        icon: <AppstoreOutlined />,
        pageComponent: <ManageDevice />,
        alarm: 0,
      },
      {
        key: "manageResistDevice",
        title: "디바이스 등록 관리",
        link: "/manageResistDevice",
        icon: <AppstoreAddOutlined />,
        pageComponent: <ManageResistDevice />,
      },
      {
        key: "statics",
        title: "통계 조회",
        link: "/statics",
        icon: <AppstoreAddOutlined />,
        pageComponent: <Statics />,
      },
    ],
  },
];

export const adminPlatformMenuData = [
  {
    key: "home",
    title: "HOME",
    link: "/home",
    icon: <HomeOutlined />,
    pageComponent: <Home />,
  },
  {
    key: "manageService",
    title: "서비스 관리",
    subMenu: [
      {
        key: "manageServiceUse",
        title: "서비스 이용 관리",
        link: "/manageServiceUse",
        icon: <ProfileOutlined />,
        pageComponent: <ManageServiceUse />,
      },
      {
        key: "manageServiceUser",
        title: "서비스 사용자 관리",
        link: "/manageServiceUser",
        icon: <UserOutlined />,
        pageComponent: <ManageServiceUser />,
      },
    ],
  },
  {
    key: "serviceUse",
    title: "서비스 이용",
    subMenu: [
      {
        key: "manageEvents",
        title: "이벤트 관리",
        link: "/manageEvents",
        icon: <IssuesCloseOutlined />,
        pageComponent: <ManageEvents />,
        new: true,
      },
      {
        key: "manageDevice",
        title: "디바이스 상태 관리",
        link: "/manageDevice",
        icon: <AppstoreOutlined />,
        pageComponent: <ManageDevice />,
        alarm: 0,
      },
      {
        key: "manageResistDevice",
        title: "디바이스 등록 관리",
        link: "/manageResistDevice",
        icon: <AppstoreAddOutlined />,
        pageComponent: <ManageResistDevice />,
      },
      {
        key: "statics",
        title: "통계 조회",
        link: "/statics",
        icon: <AppstoreAddOutlined />,
        pageComponent: <Statics />,
      },
    ],
  },
];

export const normalUserMenuData = [
  {
    key: "home",
    title: "HOME",
    link: "/home",
    icon: <HomeOutlined />,
    pageComponent: <Home />,
  },
  {
    key: "serviceUse",
    title: "서비스 이용",
    subMenu: [
      {
        key: "manageEvents",
        title: "이벤트 관리",
        link: "/manageEvents",
        icon: <IssuesCloseOutlined />,
        pageComponent: <ManageEvents />,
        new: true,
      },
      {
        key: "manageDevice",
        title: "디바이스 상태 관리",
        link: "/manageDevice",
        icon: <AppstoreOutlined />,
        pageComponent: <ManageDevice />,
        alarm: 0,
      },
      {
        key: "statics",
        title: "통계 조회",
        link: "/statics",
        icon: <AppstoreAddOutlined />,
        pageComponent: <Statics />,
      },
    ],
  },
];